<template>
 <v-container class="pt-4 pb-12 py-sm-12">
<!-- Título e Breadcrumbs -->
<v-row class="mb-4">
  <v-col cols="12">
    <div class="title-container d-flex flex-column flex-sm-row justify-space-between align-start align-sm-center">
      <div>
        <span class="page-title">Clientes</span>
        <div class="breadcrumb" style="font-size: 13px; color: #666; margin-top: 2px;">
          <span style="color:#333333; cursor:pointer;" @click="$router.push('/home')">
            Homepage
          </span>
          <span> › </span>
          <span>Clientes</span>
        </div>
      </div>
<div class="button-group mt-2 mt-sm-0 w-100 w-sm-auto">
  <!-- Mobile -->
<div class="mobile-btn-group d-flex d-sm-none flex-column w-100">
  <v-btn color="primary" dark block class="mb-btn-cadastrar" @click="cadastrarUsuario">
    Cadastrar
  </v-btn>
  <div class="mb-btn-row">
    <v-btn color="primary" dark class="mb-btn-half" @click="() => { dataList.options.page = 1; loadData(); }">
      Filtrar
    </v-btn>
    <v-btn color="primary" outlined :disabled="dataList.loading" class="mb-btn-half" @click="exportReport">
      Exportar
    </v-btn>
  </div>
</div>

  <!-- Desktop -->
  <v-btn color="primary" dark class="d-none d-sm-flex" @click="cadastrarUsuario">
    Cadastrar
  </v-btn>
  <v-btn color="primary" outlined :disabled="dataList.loading" @click="exportReport" class="d-none d-sm-flex ml-2">
    Exportar
  </v-btn>
</div>
    </div>
  </v-col>
</v-row>
    <!-- Filtros -->
     
<v-row align="center" class="mb-4">
  <v-col cols="12" sm="6" md="3" class="py-2 py-sm-0 mb-0 mb-sm-3">
  <v-text-field 
    v-model="dataset.filter.nome" 
    label="Nome" 
    dense 
    outlined 
    hide-details="auto"
    @input="limparNome"
    maxlength="100"
  />
</v-col>

<v-col cols="12" sm="6" md="3" class="py-2 py-sm-0 mb-0 mb-sm-3">
  <v-text-field
    v-model="dataset.filter.cpf"
    label="CPF"
    dense
    outlined
    hide-details="auto"
    @input="aplicarMascaraCPF"
  />
</v-col>

      <!-- <v-col cols="12" md="3">
        <v-text-field 
          v-model="dataset.filter.email" 
          label="Email" 
          dense 
          outlined 
          hide-details 
        />
      </v-col> -->

     <v-col cols="12" sm="6" md="3" class="py-2 py-sm-0 mb-0 mb-sm-3">
  <v-text-field
    v-model="dataset.filter.telefone"
    label="Telefone"
    dense
    outlined
    hide-details="auto"
    @input="aplicarMascaraTelefone"
  />
</v-col>

<!-- Desktop Filtrar (dentro da row de filtros) -->
<v-col cols="12" md="2" class="d-none d-sm-flex align-center pt-0">
  <v-btn color="primary" dark height="40" style="width: 100%; max-width: 110px; margin-top: 1px;" @click="() => { dataList.options.page = 1; loadData(); }">
    Filtrar
  </v-btn>
</v-col>
</v-row>

 <!-- Tabela -->
    <v-row>
      <v-col cols="12">
 <v-data-table
  :headers="visibleHeaders"
  :items="dataList.data"
  :loading="dataList.loading"
  :server-items-length="dataList.total"
  :options.sync="dataList.options"
  loading-text="Carregando registros..."
  no-data-text="Nenhum cliente encontrado"
  class="app-table hover-table cliente-list-table"
  disable-sort
  :footer-props="dataList.footerOptions"
  :hide-default-footer="$vuetify.breakpoint.xsOnly"
>
          <template v-slot:item.nome="{ item }">
            {{ item.nome }}
          </template>

          <template v-slot:item.cpf="{ item }">
            {{ item.cpf || '-' }}
          </template>

         <!-- <template v-slot:item.email="{ item }">
            {{ item.email || '-' }}
          </template> -->

          <template v-slot:item.telefone="{ item }">
            {{ item.telefone || '-' }}
          </template>

             <template v-slot:item.ultimaVisita="{ item }">
  {{ item.ultimaVisita ? new Date(item.ultimaVisita).toLocaleDateString('pt-BR') : '-' }}
</template>

<template v-slot:item.saldoAtual="{ item }">
  {{ item.saldoAtual != null ? 'R$ ' + Number(item.saldoAtual).toFixed(2).replace('.', ',') : 'R$ 0,00' }}
</template>

<template v-slot:item.bloqueado="{ item }">
            <span :class="!item.bloqueado ? 'green--text' : 'error--text'">
              <strong>{{ item.bloqueado ? 'Bloqueado' : 'Habilitado' }}</strong>
            </span>
          </template>

        <template v-slot:item.actions="{ item }">
          <div class="actions-cell">
            <v-btn
  small
  color="primary-200"
  @click="viewItem(item)"
  class="mr-2 action-btn-fixed"
>
              <v-icon left>mdi-pencil-outline</v-icon>
              Editar
            </v-btn>

           <v-btn small class="action-btn-fixed" style="background-color: #f44336 !important; color: white !important;" @click="abrirConfirmacaoExcluir(item)">
  <v-icon left>mdi-delete-outline</v-icon>
  Excluir
</v-btn>
          </div>
          </template>
          <div class="lista-custom-pagination d-flex d-sm-none">
  <div class="lista-pagination-topo">
    <v-select
      :items="[10, 20]"
      v-model="dataList.options.size"
      dense
      outlined
      hide-details
      class="lista-itens-por-pagina"
      @change="pageSizeChanged(dataList.options.size)"
    />
    <span class="lista-pagination-label">
      Página {{ dataList.options.page }} de {{ totalPaginasLista }}
    </span>
  </div>
  <div class="lista-pagination-botoes">
    <v-btn text small color="primary" :disabled="dataList.options.page <= 1" @click="paginaAnteriorLista">
      <v-icon left small>mdi-chevron-left</v-icon>
      Anterior
    </v-btn>
    <v-btn text small color="primary" :disabled="dataList.options.page >= totalPaginasLista" @click="paginaProximaLista">
      Próxima
      <v-icon right small>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</div>
      </v-data-table>

       <div class="lista-custom-pagination d-flex d-sm-none">
          <div class="lista-pagination-topo">
            <v-select
              :items="[10, 20]"
              v-model="dataList.options.itemsPerPage"
              dense
              outlined
              hide-details
              class="lista-itens-por-pagina"
            />
            <span class="lista-pagination-label">
              Página {{ dataList.options.page }} de {{ totalPaginasLista }}
            </span>
          </div>
          <div class="lista-pagination-botoes">
            <v-btn text small color="primary" :disabled="dataList.options.page <= 1" @click="paginaAnteriorLista">
              <v-icon left small>mdi-chevron-left</v-icon>
              Anterior
            </v-btn>
            <v-btn text small color="primary" :disabled="dataList.options.page >= totalPaginasLista" @click="paginaProximaLista">
              Próxima
              <v-icon right small>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>

             <v-dialog v-model="dialogExcluir" max-width="400">
          <v-card>
            <v-card-title>Excluir Cliente</v-card-title>
            <v-card-text>
              Deseja realmente excluir o cliente <strong>{{ clienteParaExcluir.nome }}</strong>?
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
              <v-btn style="background-color: #f44336 !important; color: white !important;" @click="executarExclusao">Excluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import { eventHub } from "@/main";
import _ from 'lodash';

export default {
  name: "ClienteList",
data() {
    return {
      dialogExcluir: false, 
      clienteParaExcluir: {}, 
      dataset: {
        filter: { 
          nome: "", 
          cpf: "", 
          email: "", 
          telefone: "" 
        }
      },
      dataList: {
        headers: [
          { text: "Nome", value: "nome" },
          { text: "CPF", value: "cpf" },
          // { text: "Email", value: "email" },
          { text: "Telefone", value: "telefone" },
          { text: "Últ. Visita", value: "ultimaVisita", hideOnMedium: true },
          { text: "Saldo Atual", value: "saldoAtual" },
          { text: "Situação", value: "bloqueado", hideOnMedium: true },
          { text: "Ações", value: "actions", sortable: false, align: 'center' }
        ],
      data: [],
loading: false,
total: 0,
loadSeq: 0,
options: { page: 1, itemsPerPage: 10 },
footerOptions: {
    itemsPerPageText: 'Itens por página:',
    itemsPerPageOptions: [10, 20],
    pageText: '{0}-{1} de {2}',
}
      }
    };
  },

mounted() {
  this.loadData();

  var self = this;
  eventHub.$on('CHANGE-OPERATION', function() {
    self.loadData();
  });
},

destroyed() {
  eventHub.$off('CHANGE-OPERATION');
},

computed: {
  totalPaginasLista() {
    const total = this.dataList.total || 0;
    const porPagina = this.dataList.options.itemsPerPage || 10;
    return Math.max(1, Math.ceil(total / porPagina));
  },
  // Últ. Visita e Situação somem em telas menores (ex: notebooks 1024x768)
  // pra tabela não precisar de scroll horizontal.
  visibleHeaders() {
    const isMediumOrSmaller = this.$vuetify.breakpoint.width < 1264;
    return this.dataList.headers.filter((h) => !(isMediumOrSmaller && h.hideOnMedium));
  }
},

  methods: {
async loadData() {
      this.dataList.loading = true;
      try {
        const operacaoId = localStorage.getItem("operation");
        if (!operacaoId || !/^[0-9a-fA-F-]{36}$/.test(operacaoId)) {
          this.dataList.data = [];
          return;
        }
        const params = {
  operacaoId: operacaoId,
  nome: this.dataset.filter.nome || null,
  cpf: this.dataset.filter.cpf ? this.dataset.filter.cpf.replace(/\D/g, "") : null,
  email: this.dataset.filter.email || null,
  telefone: this.dataset.filter.telefone ? this.dataset.filter.telefone.replace(/\D/g, "") : null,
  page: this.dataList.options.page - 1,
  size: this.dataList.options.itemsPerPage
};
const res = await axios.get("/api/clientes", { params });
const listaFinal = res.data.content || res.data;
this.dataList.total = res.data.page ? res.data.page.totalElements : (res.data.totalElements || listaFinal.length);
        listaFinal.forEach(c => {
          if (c.cpf) c.cpf = c.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
          if (c.telefone) c.telefone = c.telefone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
        });
        this.dataList.data = listaFinal;
      } catch (error) {
        console.error("Erro ao carregar clientes:", error);
        this.dataList.data = [];
      } finally {
        this.dataList.loading = false;
      }
    },

    paginaAnteriorLista() {
      if (this.dataList.options.page > 1) {
        this.dataList.options.page--;
      }
    },

    paginaProximaLista() {
      if (this.dataList.options.page < this.totalPaginasLista) {
        this.dataList.options.page++;
      }
    },

    limparNome() {
      this.$nextTick(() => {
        if (!this.dataset.filter.nome) return;
        this.dataset.filter.nome = this.dataset.filter.nome
  .replace(/[!@#$%^&*()_+={}[\]:;"'<>,.?/\\|`~]/g, "");
      });
    },

   aplicarMascaraCPF() {
      this.$nextTick(() => {
        if (!this.dataset.filter.cpf) return;

        let valor = this.dataset.filter.cpf.replace(/\D/g, "");
      
        this.dataset.filter.cpf = valor
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      });
    },

    aplicarMascaraTelefone() {
  this.$nextTick(() => {
    if (!this.dataset.filter.telefone) return;
    let valor = this.dataset.filter.telefone.replace(/\D/g, "").slice(0, 11); // 🔥 limita 11 dígitos
    this.dataset.filter.telefone = valor
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2");
  });
},
    viewItem(item) {
      this.$router.push(`/clientes/${item.id}`);
    },

    cadastrarUsuario() {
      this.$router.push("/clientes/cadastrar");
    },

    abrirConfirmacaoExcluir(item) {
      this.clienteParaExcluir = item;
      this.dialogExcluir = true;
    },

    async exportReport() {
  const operacaoId = localStorage.getItem("operation");
  if (!operacaoId || !/^[0-9a-fA-F-]{36}$/.test(operacaoId)) {
    this.$dialog.notify.error("Nenhuma operação selecionada!", { position: "top-right", timeout: 5000 });
    return;
  }

  this.dataList.loading = true;

  try {
    const params = {
      operacaoId: operacaoId,
      nome: this.dataset.filter.nome || null,
      cpf: this.dataset.filter.cpf ? this.dataset.filter.cpf.replace(/\D/g, "") : null,
      telefone: this.dataset.filter.telefone ? this.dataset.filter.telefone.replace(/\D/g, "") : null,
    };

    const result = await axios.get(`/api/clientes/relatorio/export-to-excel`, {
      params,
      responseType: 'arraybuffer'
    });

    let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    const dataFormatada = this.$moment().format('DD-MM-YYYY_HH-mm');
    link.download = `Relatório de clientes - ${dataFormatada}.xlsx`;
    link.click();

    this.$dialog.notify.info("Clientes exportados com sucesso!", { position: "top-right", timeout: 2000 });
  } catch (error) {
    var mensagem = this.$codes(error);
    if (error && error.response && error.response.data) {
      try {
        var decoded = JSON.parse(new TextDecoder().decode(error.response.data));
        if (decoded.mensagem) mensagem = decoded.mensagem;
      } catch (e) { /* ignora */ }
    }
    this.$dialog.notify.error(mensagem, { position: 'top-right', timeout: 5000 });
  } finally {
    this.dataList.loading = false;
  }
},

  async executarExclusao() {
    this.dialogExcluir = false;
    this.dataList.loading = true;
    try {
        await axios.delete(`/api/clientes/${this.clienteParaExcluir.id}`);
        this.$dialog.notify.success("Cliente excluído com sucesso.", { 
            position: "top-right", 
            timeout: 4000 
        });
        this.loadData();
    } catch (error) {
        console.error("Erro ao excluir cliente:", error);
        this.$dialog.notify.error("Erro ao tentar excluir o cliente.");
    } finally {
        this.dataList.loading = false;
    }
}

},

watch: {
    'dataList.options': {
        handler: _.debounce(function() {
            this.loadData();
        }, 300),
        deep: true,
        immediate: true,
        flush: 'post'
    }
}
};

</script>

<style>
.v-card { border-radius: 12px; }
.title-container { gap: 16px; }
.page-title { font-size: 24px; font-weight: 700; }
.green--text { color: #28a745 !important; }
.error--text { color: #dc3545 !important; }

.action-btn-fixed {
  min-width: 0 !important;
  padding: 0 10px !important;
}

/* Garante Editar/Excluir sempre lado a lado (nunca empilhados) — se a coluna
   não tiver espaço, a tabela cresce e rola horizontalmente em vez de quebrar linha */
.actions-cell {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.lista-custom-pagination {
  flex-direction: column;
  padding: 12px 8px 4px 8px;
  margin-top: 4px;
  border-top: 1px solid #eee;
  gap: 10px;
}

.lista-pagination-topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.lista-itens-por-pagina {
  max-width: 80px;
  flex: 0 0 auto;
}

.lista-pagination-label {
  font-size: 13px;
  color: #666;
  font-weight: 600;
  white-space: nowrap;
}

.lista-pagination-botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.lista-pagination-botoes .v-btn {
  min-width: auto !important;
  padding: 0 8px !important;
  font-size: 12px !important;
  text-transform: none;
}

@media (max-width: 600px) {
    .v-data-footer {
        flex-wrap: wrap !important;
        justify-content: center !important;
        padding: 4px 0 !important;
    }
    .v-data-footer__select {
        order: 1 !important;
        justify-content: center !important;
        margin: 0 !important;
    }
    .v-data-footer__pagination {
        order: 2 !important;
        margin: 0 4px !important;
    }
    .v-data-footer__icons-before {
        order: 3 !important;
        flex: 1 !important;
        justify-content: flex-end !important;
        padding-right: 8px !important;
        margin-top: 4px !important;
    }
    .v-data-footer__icons-after {
        order: 4 !important;
        flex: 1 !important;
        justify-content: flex-start !important;
        padding-left: 8px !important;
        margin-top: 4px !important;
    }
}
@media (max-width: 600px) {
  .button-group {
    padding-right: 4px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
}
/* padding/min-height/borda do modo mobile do .app-table agora é global (assets/scss/main.scss) */
@media (max-width: 768px) {
  .app-table.cliente-list-table.v-data-table--mobile tbody tr td {
  border-bottom: none !important;
}
  .app-table.cliente-list-table.v-data-table--mobile .v-data-table__mobile-row {
    padding-left: 0 !important;
  }

  .app-table.cliente-list-table.v-data-table--mobile .v-data-table__mobile-row__header {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
  .v-data-table__mobile-row .v-btn {
    min-width: unset !important;
    padding: 0 6px !important;
    font-size: 10px !important;
    height: 22px !important;
  }
}
@media (max-width: 600px) {
  .mobile-btn-group {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    flex: 1 1 100% !important;
    padding-right: 16px;
  }
  .mb-btn-cadastrar {
    width: 100% !important;
    height: 44px !important;
    margin-bottom: 10px;
  }
  .mb-btn-row {
    display: flex !important;
    flex-direction: row !important;
    gap: 10px;
    width: 100%;
  }
  .mb-btn-half {
    flex: 1 1 0 !important;
    min-width: 0;

  }
}
@media (max-width: 600px) {
  .mobile-btn-group {
    margin-bottom: -12px;
  }
}
@media (min-width: 600px) {
  .button-group {
    margin-right: 32px;
  }
}

</style>